import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'
import {Image, Tiles} from '@primer/react-brand/esm'

import EclipseIcon from '../../_components/IdeList/ide-icons/eclipse.svg'
import GitHubIcon from '../../_components/IdeList/ide-icons/github.svg'
import JetBrainsIcon from '../../_components/IdeList/ide-icons/jetbrains-logo.svg'
import NeovimIcon from '../../_components/IdeList/ide-icons/neovim.svg'
import RaycastIcon from '../../_components/IdeList/ide-icons/raycast-logo.svg'
import SqlServerManagementStudioIcon from '../../_components/IdeList/ide-icons/sql-server-management-studio-logo.svg'
import VisualStudioIcon from '../../_components/IdeList/ide-icons/visualstudio.webp'
import VSCodeIcon from '../../_components/IdeList/ide-icons/vscode.svg'
import XcodeIcon from '../../_components/IdeList/ide-icons/xcode.svg'
import ZedIcon from '../../_components/IdeList/ide-icons/zed.svg'

const logoTiles = [
  {
    name: 'GitHub',
    href: 'https://github.com/copilot',
    image: GitHubIcon,
    action: 'github',
  },
  {
    name: 'VS Code',
    href: 'https://marketplace.visualstudio.com/items?itemName=GitHub.copilot-chat',
    image: VSCodeIcon,
    action: 'vscode',
  },
  {
    name: 'Visual Studio',
    href: 'https://visualstudio.microsoft.com/github-copilot',
    image: VisualStudioIcon,
    action: 'vs',
  },
  {
    name: 'Xcode',
    href: 'https://github.com/github/CopilotForXcode',
    image: XcodeIcon,
    action: 'xcode',
  },
  {
    name: 'JetBrains IDEs',
    href: 'https://plugins.jetbrains.com/plugin/17718-github-copilot',
    image: JetBrainsIcon,
    action: 'jetbrains',
  },
  {
    name: 'Neovim',
    href: 'https://github.com/github/copilot.vim',
    image: NeovimIcon,
    action: 'neovim',
  },
  {
    name: 'Eclipse',
    href: 'https://marketplace.eclipse.org/content/github-copilot#details',
    image: EclipseIcon,
    action: 'eclipse',
  },
  {
    name: 'Raycast',
    href: 'https://gh.io/copilot-raycast-docs',
    image: RaycastIcon,
    action: 'raycast',
  },
  {
    name: 'SQL Server Management Studio',
    href: 'https://learn.microsoft.com/ssms/github-copilot/get-started',
    image: SqlServerManagementStudioIcon,
    action: 'sqlservermanagementstudio',
  },
  {
    name: 'Zed',
    href: 'https://zed.dev/acp/agent/github-copilot',
    image: ZedIcon,
    action: 'zed',
  },
]

type Props = {
  location: string
}

export function LogoTiles({location}: Props) {
  return (
    <Tiles variant="gridlines" layout="compact">
      {logoTiles.map(({name, href, image, action}) => (
        <Tiles.Item
          key={action}
          name={name}
          href={href}
          data-ide={action}
          {...getAnalyticsEvent({
            action,
            tag: 'icon',
            context: 'editors',
            location,
          })}
        >
          <Image src={`${image}?v=1`} alt="" width="32" height="32" />
        </Tiles.Item>
      ))}
    </Tiles>
  )
}
